import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SettingsService } from '../services/settings.service';

@Injectable()
export class PasswordResetService {

  constructor(
    private http: HttpClient,
    private settings: SettingsService
  ) { }

  /**
   * Permite al usuario cambiar su clave
   * @param body clave actual y nueva clave
   * @returns suscripcion con devolucion de llamada
   */
  cambiarClave(body: any, token: string): Observable<any> {
    
    const headerDict = {
      'Authorization': `Bearer ${token}`
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict)
    }

    return this.http.put(`${this.settings.URL_BASE}seguridad/usuario/cambio/clave`, body, requestOptions);

  }

}
